module.exports = __webpack_public_path__ + "static/kent-844b0c3bb5d3ffc2c4700f906b74a167.png";